import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FaceIdSvg = function FaceIdSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 2h7v7h-1.5V3.5H15zM2 22h7v-1.5H3.5V15H2zM15 22h7v-7h-1.5v5.5H15zM2 2h7v1.5H3.5V9H2zM8.218 10.598a.47.47 0 0 1-.468-.468V8.718a.468.468 0 0 1 .936 0v1.412c0 .259-.21.468-.468.468M13.034 12.268V8.745a.495.495 0 0 0-.991 0v3.523a.276.276 0 0 1-.275.275h-.404a.495.495 0 1 0 0 .99h.404c.698 0 1.266-.567 1.266-1.265M15.363 14.849a.495.495 0 0 1-.028.7 4.84 4.84 0 0 1-3.292 1.287 4.84 4.84 0 0 1-3.292-1.287.495.495 0 0 1 .672-.728 3.85 3.85 0 0 0 2.62 1.024 3.85 3.85 0 0 0 2.62-1.024.495.495 0 0 1 .7.028M16.446 8.718v1.412a.468.468 0 0 1-.936 0V8.718a.468.468 0 0 1 .936 0"
  }));
};
export var FaceId = function FaceId(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FaceIdSvg
  }));
};